import React from "react";

const CustomMessage = (props) => {
	if (props.message === "__LOADING__") {
    	return (<div class="react-chatbot-kit-chat-bot-message">
					<span>
						<div class="chatbot-loader-container">
							<svg id="dots" width="50px" height="21px" viewBox="0 0 132 58" version="1.1" xmlns="http://www.w3.org/2000/svg">
								<g stroke="none" fill="none">
									<g id="chatbot-loader" fill="#fff">
										<circle id="chatbot-loader-dot1" cx="25" cy="30" r="13"></circle>
										<circle id="chatbot-loader-dot2" cx="65" cy="30" r="13"></circle>
										<circle id="chatbot-loader-dot3" cx="105" cy="30" r="13"></circle>
									</g>
								</g>
							</svg>
						</div>
					</span>
					<div class="react-chatbot-kit-chat-bot-message-arrow"></div>
				</div>		
    		);
  	}
  	return (<div className="react-chatbot-kit-chat-bot-message">
  				<span>{props.message}</span>
  				<div class="react-chatbot-kit-chat-bot-message-arrow"></div>
  		  	</div>);
};

export default CustomMessage;